import { render, staticRenderFns } from "./outboundOrderForm.vue?vue&type=template&id=b369d0da&scoped=true"
import script from "./outboundOrderForm.vue?vue&type=script&lang=js"
export * from "./outboundOrderForm.vue?vue&type=script&lang=js"
import style0 from "./outboundOrderForm.vue?vue&type=style&index=0&id=b369d0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b369d0da",
  null
  
)

export default component.exports